import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ye7gebvth: FaireProductEntity = {
  token: "p_6ye7gebvth",
  type: "product",
  name: "Rewined Market Fig & Tomato 6 oz Tin Candle",
  brandToken: "b_7a75656a",
  brandName: "Rewined",
  imageUrl:
    "https://cdn.faire.com/fastly/0de939e59bd870211ab622ef14b345089f1a5a456b68be66501da8dd871dfe33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af9d0710578fc1bb0f5c71d9c4d3f09470a938284f5773b74a4ee14be2c087fd.jpeg",
  ],
  priceDollars: 11,
  description:
    "Notes of Tomato Leaves, Fig Fruit, Cedarwood, and Vetiver.\nSoy/Paraffin Wax Blend.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:37.263Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
